// CONSTANTS are all caps.
const NS = 'WishlistCdc';
const CLS = 'wishlistCdc';
const PG = '.' + CLS + '-';
import LazyLoad from 'vanilla-lazyload/dist/lazyload';
import * as Api from '../../../../global/js/api';
import * as utils from '../../../../global/js/utils';
import * as cart from '../../../../global/js/cart';
import * as dataLayer from '../../../../global/js/dataLayer';
import {UPDATE_CART} from '../../../widgets/headerCart/js/headerCart';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadPg.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'


export class WishlistCdc {
	constructor($el) {
		// $el is the page node return by the loadWishlistCdc function
		this.$el = $el;
		this.$pg = $(this.$el);
		this.apiEndpoint = {
			removeEndpoint: this.$pg.data('removeItemApiEndpoint'),
			moveAllApiEndpoint: this.$pg.data('move-all-api-endpoint'),
			moveItemApiEndpoint: this.$pg.data('move-item-api-endpoint'),
			recommendationsEndpoint: this.$pg.data('recommendations-endpoint'),
			cartEndpoint: this.$pg.data('cart-endpoint'),
		};
		this.selectedId = null;
		this.$selectedItem = null;
	}

	init() {
		this.setWishlistCdc();
	}

	setWishlistCdc() {
		this.lazyLoadImg();
		this.registerEvent();
	}

	lazyLoadImg() {
		const That = this;
		That.myLazyLoad = new LazyLoad({
			elements_selector: '.lazy',
		});
	}

	registerEvent() {
		this.regsiterRemoveItem();
		this.registerAddAllToCart();
		this.registerAddToCart();
	}

	registerAddToCart() {
		const This = this;
		This.$pg.on('click', '.wishCartItem-add-to-cart', function() {
			This.selectedId = $(this).data('code');
			This.$selectedItem = $(this).closest('.wishCart');
			$('#moveToCartModal').modal('show');
		});

		This.$pg.on('click', '#addToCart', function() {
			This.addToCart();
		});
	}

	regsiterRemoveItem() {
		const This = this;
		This.$pg.on('click', '.wishCartItem-remove-wishitem', function() {
			This.selectedId = $(this).data('id');
			This.$selectedItem = $(this).closest('.wishCart');
			$('#removeWishCartModal').modal('show');
		});

		This.$pg.on('click', '#removeWishItem', function() {
			This.removeWishItem();
		});
	}

	registerAddAllToCart() {
		this.$pg.on('click', '#addAllToCart', () => {
			this.addAllToCart();
		});
	}

	addToCart() {
		const param = {
			id: this.selectedId,
			quantity: 1,
		};

		this.hideMessage();
		utils.showLoading();

		Api.callApi(this.apiEndpoint.moveItemApiEndpoint, param).then((data) => {
			if (data && data.result === 'SUCCESS') {
				this.updateCounter(data.response);

				const details = {
					mods: data.message ? 'has-error' : '',
					isCart: true,
					count: data.response.cartCount,
					title: this.$selectedItem.data('title'),
					total: '$' + parseFloat(data.response.cartTotal || 0).toFixed(2),
					addedText: 'Added to cart',
					link: this.apiEndpoint.cartEndpoint || '#',
					qty: data.quantityActual,
					itemImg: this.$selectedItem.data('itemImg'),
					errorMsg: data.message,
					productCode: data.code,
					recommendationsApi: this.apiEndpoint.recommendationsEndpoint || '',
					recommendationsTitle: data.response.recommendationsTitle || '',
					recommendationsViewMoreLink: data.response.recommendationsViewMoreLink || '',
					recommendationId: data.response.recommendationId || '',
				};

				cart.showNotification(details);

				dataLayer.pushAddToCart({
						code: data.code,
						quantity: data.quantityActual
					},
					window.wishlistDatalayerDataSource
				);

				this.$selectedItem.remove();
			} else {
				this.showMessage(data);
			}
		}).finally(() => {
			$('#moveToCartModal').modal('hide');
			utils.hideLoading();
			this.resetData();
			this.updateButtonAddAll();
		});
	}

	removeWishItem() {
		const param = {
			id: this.selectedId,
		};

		this.hideMessage();
		utils.showLoading();

		Api.callApi(this.apiEndpoint.removeEndpoint, param).then((data) => {
			if (data && data.result === 'SUCCESS') {
				this.$selectedItem.remove();
				this.updateCounterElement(
					data.response.lineitemscount,
					$('.siteHeader-wishlist .siteHeader-cartCount, .js-wishlist .siteHeader-cartCount')
				);
			} else {
				this.showMessage(data);
			}
		}).finally(() => {
			$('#removeWishCartModal').modal('hide');
			this.$pg.find('.wishCart').length === 0 && this.$pg.find('.wishlistCdc-content').addClass('is-empty');
			utils.hideLoading();
			this.resetData();
			this.updateButtonAddAll();
		});
	}

	addAllToCart() {
		utils.showLoading();
		this.hideMessage();

		Api.callApi(this.apiEndpoint.moveAllApiEndpoint).then((data) => {
			if (data && data.result === 'SUCCESS') {
				this.$pg.find('.wishCart:not(.is-store-only)').remove();
				this.updateCounter(data.response);
				$(document).trigger(UPDATE_CART);
			}
			this.showMessage(data);
		}).finally(() => {
			$('#modalAddAllToCart').modal('hide');
			utils.hideLoading();
			this.updateButtonAddAll();
		});
	}

	updateButtonAddAll() {
		if (this.$pg.find('.wishCart').length === 0) {
			this.$pg.find('.wishlistCdc-content').addClass('is-empty');
			this.$pg.find('.add-all-to-cart').remove();
		}
	}

	resetData() {
		this.$selectedItem = null;
		this.selectedId = null;
	}

	updateCounter({cartCount, wishlistCount}) {
		this.updateCounterElement(
			cartCount,
			$('.siteHeader-cartIcon .siteHeader-cartCount, .header-item-cart .siteHeader-cartCount, .siteHeader-cart .siteHeader-cartCount')
		);
		this.updateCounterElement(
			wishlistCount,
			$('.siteHeader-wishlist .siteHeader-cartCount, .js-wishlist .siteHeader-cartCount')
		);
	}

	updateCounterElement(count, $element) {
		const INVISIBLE = 'invisible';
		$element.text(count);
		if (parseInt(count || 0)) {
			$element.removeClass(INVISIBLE);
		} else {
			$element.addClass(INVISIBLE);
		}
	}

	showMessage(data) {
		if (data.message) {
			const $message = document.getElementById('message');
			$($message).text(data.message).addClass('is-active');
			$message.scrollIntoView({behavior: 'smooth', block: 'center', inline: 'nearest'});
		}
	}

	hideMessage() {
		const $message = $('#message');
		$message.empty().removeClass('is-active');
	}
}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_04/_work/396/s/FrontEnd/src/views/pages/wishlistCdc/js/wishlistCdc.js